import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import axios from "axios";

const AssignSpecialtiesModal = ({ showModal, hideModal, hospitalId, assignedSpecialties, onSuccess }) => {
    const [allSpecialties, setAllSpecialties] = useState([]);
    const [filteredSpecialties, setFilteredSpecialties] = useState([]);
    const [selectedSpecialties, setSelectedSpecialties] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const fetchSpecialties = async () => {
            try {
                const { data } = await axios.get(`/speciality`);
                const unassignedSpecialties = data.filter(
                    (specialty) =>
                        !assignedSpecialties.some(
                            (assigned) => assigned.specialty_id === specialty.specialty_id
                        )
                );
                setAllSpecialties(unassignedSpecialties);
                setFilteredSpecialties(unassignedSpecialties); // Initially, all unassigned specialties are shown
            } catch (error) {
                console.error("Failed to fetch specialties:", error);
            }
        };

        if (showModal) {
            fetchSpecialties();
        }
    }, [showModal, assignedSpecialties]);

    const handleSearchChange = (e) => {
        const term = e.target.value.toLowerCase();
        setSearchTerm(term);
        setFilteredSpecialties(
            allSpecialties.filter((specialty) =>
                specialty.name.toLowerCase().includes(term)
            )
        );
    };

    const toggleSpecialtySelection = (specialty) => {
        setSelectedSpecialties((prevSelected) => {
            if (prevSelected.some((item) => item.specialty_id === specialty.specialty_id)) {
                return prevSelected.filter((item) => item.specialty_id !== specialty.specialty_id);
            } else {
                return [...prevSelected, specialty];
            }
        });
    };

    const handleAssignSpecialties = async () => {
        try {
            const specialtyIds = selectedSpecialties.map((specialty) => specialty.specialty_id);
            await axios.post(`/assign_speciality`, { hospitalId, specialtyIds });
            onSuccess();
            hideModal();
        } catch (error) {
            console.error("Failed to assign specialties:", error);
            alert("Error assigning specialties.");
        }
    };

    return (
        <Modal show={showModal}style={{marginTop: "60px"}} onHide={hideModal} size="lg" centered backdrop={false}>
            <Modal.Header closeButton>
                <Modal.Title>Assign Specialties</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <InputGroup className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Search specialties"
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                </InputGroup>
                <Form>
                    {filteredSpecialties.length === 0 && <p>No specialties found.</p>}
                    {filteredSpecialties.map((specialty) => (
                        <Form.Check
                            key={specialty.specialty_id}
                            type="checkbox"
                            label={specialty.name}
                            checked={selectedSpecialties.some(
                                (item) => item.specialty_id === specialty.specialty_id
                            )}
                            onChange={() => toggleSpecialtySelection(specialty)}
                        />
                    ))}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={hideModal}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleAssignSpecialties}>
                    Assign
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AssignSpecialtiesModal;
